import { roles } from "constants/index";

export const rolesGetAllShop = [roles.admin, roles.regionManager, roles.viceRegionManager, roles.seniorAreaManager]

export const rolesImport = [roles.admin, roles.departmentManager]

export const rolesEditBudget = [roles.admin, roles.departmentManager, roles.shopManager]

export const rolesEditNote = [roles.admin, roles.departmentManager, roles.shopManager]

export const rolesAdminRevenue = [roles.admin];